import { render, staticRenderFns } from "./UpgradeQuote.vue?vue&type=template&id=bf20a536&"
import script from "./UpgradeQuote.vue?vue&type=script&lang=js&"
export * from "./UpgradeQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports